import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { useLang } from "@/context/LanguageContext";
import { Minus, Plus } from "lucide-react";

export function PortionsDialog({ open, onClose, meal, members, onChange, busy }) {
  const { t, tv } = useLang();
  if (!meal) return null;
  const present = members.filter((m) => meal.servings?.[m.member_id] != null);
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="rounded-3xl max-w-md" data-testid="portions-dialog">
        <DialogHeader>
          <DialogTitle className="font-serif text-2xl">{t("portions_title")}</DialogTitle>
          <DialogDescription>{tv(meal.name)}</DialogDescription>
        </DialogHeader>
        <div className="space-y-2">
          {present.map((m) => {
            const p = meal.servings[m.member_id];
            const nut = meal.nutrition_by_member?.[m.member_id];
            return (
              <div key={m.member_id} className="flex items-center justify-between rounded-2xl bg-secondary/60 px-4 py-3" data-testid={`portion-row-${m.member_id}`}>
                <div>
                  <p className="font-medium">{m.name}</p>
                  {nut && <p className="text-xs text-muted-foreground">{nut.calories} {t("kcal")} · P {nut.protein}g</p>}
                </div>
                <div className="flex items-center gap-2">
                  <button disabled={busy || p <= 0.25} onClick={() => onChange(m.member_id, p - 0.25)} data-testid={`portion-minus-${m.member_id}`}
                    className="grid place-items-center h-9 w-9 rounded-full border border-border hover:bg-background disabled:opacity-40"><Minus className="h-4 w-4" /></button>
                  <span className="font-serif text-xl font-semibold w-12 text-center" data-testid={`portion-value-${m.member_id}`}>{p}</span>
                  <button disabled={busy || p >= 4} onClick={() => onChange(m.member_id, p + 0.25)} data-testid={`portion-plus-${m.member_id}`}
                    className="grid place-items-center h-9 w-9 rounded-full border border-border hover:bg-background disabled:opacity-40"><Plus className="h-4 w-4" /></button>
                </div>
              </div>
            );
          })}
        </div>
      </DialogContent>
    </Dialog>
  );
}
